/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Test_SoundInputs */

const vi_station_test_sound = /** @type {(inputs: Station_Test_SoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thử loa`)
};

/**

* @param {Station_Test_SoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_test_sound = /** @type {((inputs?: Station_Test_SoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Test_SoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_test_sound(inputs)
});